"use strict";
/**
 * The file contents for the current environment will overwrite these during
 * build. The build system defaults to the dev environment which uses
 * `environment.ts`, but if you do `ng build --env=prod` then
 * `environment.prod.ts` will be used instead. The list of which env maps to
 * which file can be found in `angular-cli.json`. `.env.ts` is generated by the
 * `npm run env` command import env from './.env';
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ignore
 */
var production = 'true';
var serverUrl = 'https://ruckit-platform.herokuapp.com/api/';
var imageServerUrl = 'http://ruckit-platform.s3-website-us-east-1.amazonaws.com';
var resizeImageServerUrl = 'https://d8ojjhfh4a4yx.cloudfront.net';
var errorTrackingEnv = 'production';
var googleMapsKey = 'AIzaSyBnyQsblAiJeVVAHKQyo76Nx8PVp-N2mLU';
var applicationVersion = 'c18263569633285267aa8befa9fd911e86af33bb';
var scaleitUrl = 'https://api.scaleitusa.com/api/ruckit/v1/';
var s3ServerUrl = 'https://s3.amazonaws.com/ruckit-platform/';
var ticketManagerUrl = 'https://tickets.goruckit.com';
var ordersUrl = 'https://orders.goruckit.com';
exports.environment = {
    production: production === 'true',
    serverUrl: serverUrl,
    imageServerUrl: imageServerUrl,
    resizeImageServerUrl: resizeImageServerUrl,
    s3ServerUrl: s3ServerUrl,
    scaleitUrl: scaleitUrl,
    ticketManagerUrl: ticketManagerUrl,
    ordersUrl: ordersUrl,
    errorTrackingEnv: errorTrackingEnv,
    applicationVersion: applicationVersion,
    defaultLanguage: 'en-US',
    supportedLanguages: [
        'en-US',
        'fr-FR'
    ],
    googleMapsKey: googleMapsKey
};
